<template>
  <div id="projBidBusiOpptyList">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" />
    </eb-header>
    <div class="order-box">
      <eb-order @getOrderData="getOrderData" :orderData='orderData' />
    </div>
    <div class="list-box">
      <div class="card-box" v-for="item in listData" :key="item.projectCode">
        <eb-card-three>
          <ProjBidBusiOpptyListCard :project="item" />
        </eb-card-three>
      </div>
    </div>
    <eb-pagination :current-page.sync="pageNumber" v-if="paginationSize" @current-change="paginationData" :total="paginationSize" />
    <div v-if="(listRequestData.content)||!listData" class="noSearchText">未搜索到结果</div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import ebOrder from '@/components/common/eb-order';
import ebCardThree from '@/components/common/card/eb-card-three';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import ProjBidBusiOpptyListCard from '@/components/project/bid/list/ProjBidBusiOpptyListCard';
import { listBusiness } from '@/services/proj/bid-project-service';
export default {
  name: 'projBidBusiOpptyList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    ebOrder,
    ebCardThree,
    ebPagination,
    ProjBidBusiOpptyListCard
  },
  data() {
    return {
      listData: null,
      paginationSize: null,
      orderData: {
        startTime: { text: '按发布时间', adesc: null },
        endTime: { text: '按截标时间', adesc: null }
      },
      listRequestData: {
        number: 10,
        page: 1,
        content: '',
        supplierDepartId: this.$store.state.user.userInfo.departId,
        orderAdesc: null
      },
      pageNumber: 1
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listBusiness(this.listRequestData);
        if (data.returnCode === '01') {
          this.listData = data.projectList;
          this.paginationSize = data.size;
        } else if (data.returnCode === '00') {
        } else {
          this.$message.error('获取项目列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    // 初始化参数
    resetListRequestData() {
      this.listRequestData.page = 1;
      this.pageNumber = 1;
    },
    // 点击按照什么排序
    getOrderData: function(data) {
      this.resetListRequestData();
      this.listRequestData.orderAdesc = data;
      this.init();
    },
    // 点击搜索
    searchData: function(data) {
      this.resetListRequestData();
      this.listRequestData.content = data;
      this.init();
    },
    // 点击分页
    paginationData: function(data) {
      this.listRequestData.page = data;
      this.init();
    }
  }
};
</script>
<style lang="less" scoped>
#projBidBusiOpptyList {
  .order-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px 49px 15px 36px;
  }
  .card-box {
    margin-bottom: 33px;
  }
  .noSearchText {
    font-size: 21px;
    margin-top: 20px;
    text-align: center;
  }
}
</style>
